import heroMerkuri from '../../../../assets/publik/hero-merkuri.jpg';
import heroPcbs from '../../../../assets/publik/hero-pcbs.jpg';
import heroPelayanan from '../../../../assets/publik/hero-pelayanan.jpg';
import heroKonvensi from '../../../../assets/publik/hero-konvensi.jpg';

/*
 * Path ditulis langsung, tidak diimpor dari services/routes: routes.js mengimpor
 * halaman-halaman yang mengimpor berkas ini, dan nilai di bawah dibaca saat modul
 * dimuat - impor melingkar akan membuatnya belum terdefinisi.
 */
const DATABASE_B3_PATH = '/database-b3';
const MONITORING_MERCURY_PATH = '/pemantauan-merkuri';
const LOGIN_PATH = '/masuk';

/*
 * Empat topik tampilan publik. `kategori` adalah NAMA kategori di tabel Category
 * (dibuat skrip api/prisma/data-scripts/20261105_kategori_topik_publik.sql) dan
 * dipakai sebagai filter categoryName pada API pencarian berita, artikel, galeri,
 * dan dokumen - jadi harus sama persis dengan nama di basis data. `kataFaq`
 * dipakai untuk mendahulukan FAQ yang menyebut topik itu (FAQ tidak berkategori).
 */
export const TOPIK = [
    {
        slug: 'merkuri',
        kategori: 'Merkuri',
        judul: 'Merkuri',
        pengantar:
            'Portal informasi resmi mengenai bahaya, regulasi, dan upaya pengurangan penggunaan merkuri demi melindungi kesehatan masyarakat serta kelestarian lingkungan',
        gambar: heroMerkuri,
        sebutan: 'merkuri',
        kataFaq: 'merkuri',
        // Halaman lama yang tidak lagi punya menu sendiri (keputusan pengguna
        // 5 Nov 2026): ditautkan dari halaman Merkuri.
        layananTerkait: [
            {
                label: 'DATABASE B3 & POPS',
                judul: 'Database B3 dan POPs',
                uraian: 'Telusuri data bahan berbahaya dan beracun serta bahan pencemar organik persisten.',
                ke: DATABASE_B3_PATH,
            },
            {
                label: 'PEMANTAUAN',
                judul: 'Mercury Monitoring',
                uraian: 'Peta hasil pemantauan merkuri dan wilayah pertambangan rakyat.',
                ke: MONITORING_MERCURY_PATH,
            },
            {
                label: 'PROGRAM',
                judul: 'Motivasi Merkuri',
                uraian: 'Aplikasi pelaporan dan pendampingan pengurangan penggunaan merkuri.',
                href: process.env.REACT_APP_MOTIVASI_MERKURI_URL,
            },
        ],
    },
    {
        slug: 'pcbs',
        kategori: 'PCB Free Indonesia',
        judul: 'PCBs Free Indonesia',
        pengantar:
            'Portal informasi dan layanan terpadu untuk mendukung pengelolaan serta penghapusan PCBs (Polychlorinated Biphenyls) demi mewujudkan Indonesia bebas bahan kimia berbahaya',
        gambar: heroPcbs,
        sebutan: 'PCBs',
        kataFaq: 'pcb',
    },
    {
        slug: 'pelayanan-publik',
        kategori: 'Pelayanan Publik',
        judul: 'Pelayanan Publik',
        pengantar:
            'Portal resmi layanan digital B3 untuk mempermudah perizinan, konsultasi, serta pengaduan publik dan industri terkait bahan berbahaya dan beracun.',
        gambar: heroPelayanan,
        sebutan: 'pelayanan publik',
        kataFaq: 'pelayanan',
    },
    {
        slug: 'konvensi-internasional',
        kategori: 'Konvensi Internasional',
        judul: 'Konvensi Internasional',
        pengantar:
            'Portal informasi resmi mengenai penerapan dan ratifikasi konvensi internasional pengelolaan B3 serta limbahnya dan peran Indonesia pada konvensi tersebut.',
        gambar: heroKonvensi,
        sebutan: 'konvensi internasional',
        kataFaq: 'konvensi',
    },
];

/* Butir menu Informasi: empat topik lalu pintu masuk ke aplikasi PILAR. */
export const MENU_INFORMASI = [
    ...TOPIK.map((t) => ({ label: t.kategori, ke: `/informasi/${t.slug}` })),
    { label: 'PILAR B3', ke: LOGIN_PATH },
];

/*
 * Halaman per konvensi. Isi bagian Sejarah, Ketentuan Konvensi, dan Peran
 * Indonesia menunggu teks dari customer - selama `isi` kosong halaman
 * menampilkan keterangan "segera tersedia". Untuk mengisi: tulis paragraf
 * (array string) pada kunci yang sesuai.
 */
export const KONVENSI = [
    { slug: 'stockholm', judul: 'Konvensi Stockholm', isi: { sejarah: [], ketentuan: [], peran: [] } },
    { slug: 'rotterdam', judul: 'Konvensi Rotterdam', isi: { sejarah: [], ketentuan: [], peran: [] } },
    { slug: 'minamata', judul: 'Konvensi Minamata', isi: { sejarah: [], ketentuan: [], peran: [] } },
];

/* Kartu "Dokumen & Peraturan" di halaman topik, mengarah ke daftar dokumen bertopik. */
export const kartuDokumen = (topik) => [
    {
        label: 'PERATURAN',
        ikon: 'buku',
        judul: `Peraturan & kebijakan ${topik.sebutan}`,
        uraian: `Akses peraturan, kebijakan, dan pedoman yang mengatur pengelolaan dan penggunaan ${topik.sebutan}.`,
        tautan: 'Jelajahi peraturan',
    },
    {
        label: 'PANDUAN',
        ikon: 'papan',
        judul: 'Panduan pengelolaan & layanan',
        uraian: `Temukan panduan operasional, prosedur, dan informasi layanan untuk pengguna jasa pengelolaan ${topik.sebutan}.`,
        tautan: 'Jelajahi panduan',
    },
    {
        label: 'LAPORAN & DATA',
        ikon: 'buku',
        judul: `Laporan & data ${topik.sebutan}`,
        uraian: `Akses laporan, statistik, dan informasi data terkait pengelolaan dan penggunaan ${topik.sebutan}.`,
        tautan: 'Jelajahi laporan',
    },
];
